/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/~/lodash/_freeGlobal.js
// module id = 3055
// module chunks = 4